<template>
  <li>
    <span class="word">{{ item.text }}</span>
    <span class="num">{{
      item.frequency | roundFloatingPointNumber(2) | separateNumber
    }}</span>
    <div class="line">
      <div
        class="p-contentplans-graph__bar"
        :style="{ height: '10px', width: barW + '%' }"
      ></div>
    </div>
  </li>
</template>

<script>
export default {
  props: ['item', 'max'],
  data() {
    return {
      barW: 0,
      timeout: null
    };
  },
  watch: {
    'item.frequency': {
      handler(value) {
        this.update();
      }
    },
    max: {
      handler(value) {
        this.update();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.timeout = setTimeout(() => {
        this.update();
      }, 100);
    });
  },
  destroyed() {
    clearTimeout(this.timeout);
  },
  methods: {
    update() {
      let value = this.item.frequency;
      if (value && this.max) {
        this.barW = (value / this.max) * 100;
      }
    }
  }
};
</script>
